import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {InvoiceItem} from "../types.ts";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

const formatAmount = (amount?: number, currency?: string) => {
    if (typeof amount !== 'number') return '';
    const display = (amount / 100).toFixed(2);
    return currency ? `${display} ${currency.toUpperCase()}` : display;
};

const formatPeriod = (period?: { start?: string, end?: string }) => {
    if (!period?.start && !period?.end) return '';
    const start = period.start ? formatTimestamp(period.start) : '—';
    const end = period.end ? formatTimestamp(period.end) : '—';
    return `${start} → ${end}`;
};

export const useTableColumns = (
    _props?: { onRecordClick?: (record: InvoiceItem) => void },
) => {

    const columns: DataTableColumn<InvoiceItem>[] = [
        {
            accessor: 'description',
            title: I18n.get('Description'),
            width: '2fr',
            render: (record: InvoiceItem) => record.description || record.id,
        },
        {
            accessor: 'amount',
            title: I18n.get('Amount'),
            width: '1fr',
            render: (record: InvoiceItem) => formatAmount(record.amount, record.currency),
        },
        {
            accessor: 'quantity',
            title: I18n.get('Quantity'),
            width: '0.5fr',
        },
        {
            accessor: 'period',
            title: I18n.get('Period'),
            width: '2fr',
            render: (record: InvoiceItem) => formatPeriod(record.period),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (record: InvoiceItem) => formatTimestamp(record.created),
        },
    ];

    return {
        columns,
    };
};
